
export default {
  /*
   *
   * @example
   *
   * import utils from '@vue/utils/date.utils'
   * utils.hoursUntil(new Date('2025-07-29T16:00:00+01:00'));
   * utils.destructureDate(new Date('2025-07-29T16:00:00+01:00'));
   * 
  */

  hoursUntil: (date) => {
    return Math.floor((new Date(date) - new Date()) / (1000 * 60 * 60));
  },

  destructureDate: (date) => {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear()
    }
  },

  getAge: (dob) => {
    const birth = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birth.getFullYear();

    const hasBirthdayPassed =
      today.getMonth() > birth.getMonth() ||
      (today.getMonth() === birth.getMonth() &&
      today.getDate() >= birth.getDate());

    if (!hasBirthdayPassed) {
      age--;
    }

    return age;
  }
}
